import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    link: {
        flexWrap: 'wrap',
        paddingRight: 20,
        textDecoration: 'none',
    },
    active: {
        color: '#',
        fontWeight: 'bold'
    }
}));

export default function ButtonAppBar() {
    const classes = useStyles();

    return (
        <Grid container>
            {/* <Grid item sm={12}> */}
            <AppBar color='default' position="static">
                <Toolbar>
                    <NavLink activeClassName={classes.active} className={classes.link} to="/dashboard">
                        Home
          </NavLink>
                    {/* <NavLink activeClassName={classes.active} to="/users" className={classes.link}>
                        Users
          </NavLink> */}
                    <NavLink activeClassName={classes.active} to="/managers" className={classes.link}>
                        Managers
          </NavLink>
                    <NavLink activeClassName={classes.active} to="/boys" className={classes.link}>
                        Boys
          </NavLink>
                    <NavLink to="/" style={{
                        flexWrap: 'wrap',
                        textDecoration: 'none',
                        flex: 1, textAlign: 'right'
                    }}>
                        Logout
          </NavLink>
                </Toolbar>
            </AppBar>
        </Grid>
        // </Grid>
    );
}